import { ReactNode } from 'react'
import { DropdownOptionParams } from '../at-dropdown'
import { Listbox, ListboxButton } from '@headlessui/react'
import { Pill } from './pill'
import { DropdownListbox } from '../at-dropdown/dropdown-listbox'
import { useRef } from 'react'
import { useScrollToSelf } from '../../utils'

export type AtPillDropdownProps = DropdownOptionParams & {
  id?: string
  label: string
  disabled?: boolean
  className?: string
  pillClassName?: string
  pillArrowClassName?: string
  dropdownClassName?: string
  /** Optional icon to show to the left of the selected value (e.g. MapPin when city selected via geolocation) */
  valueIcon?: ReactNode
}

export const AtPillDropdown = ({
  id,
  label,
  onChange,
  options,
  value,
  disabled,
  className,
  pillClassName,
  pillArrowClassName,
  dropdownClassName,
  valueIcon,
}: AtPillDropdownProps) => {
  const pillButtonRef = useRef<HTMLDivElement>(null)

  const handleScrollToSelf = useScrollToSelf(pillButtonRef)

  return (
    <div id={id} ref={pillButtonRef} onClick={handleScrollToSelf}>
      <Listbox onChange={onChange} value={value} disabled={disabled}>
        <ListboxButton
          className={`group focus:outline-none focus-visible:outline focus-visible:outline-1 focus-visible:outline-neutrals-900 outline-offset-4 min-w-fit inline-grid ${
            className ?? ''
          }`}
        >
          {({ open }) => (
            <Pill
              open={open}
              value={value?.label}
              valueIcon={valueIcon}
              label={label}
              disabled={disabled}
              className={pillClassName}
              arrowClassName={pillArrowClassName}
            />
          )}
        </ListboxButton>
        <DropdownListbox
          options={options}
          anchorTo="bottom start"
          className={`max-w-full w-[21.4375rem] mr-6 ${dropdownClassName ?? ''}`}
        />
      </Listbox>
    </div>
  )
}
